<template lang="pug">
div
  messages(
    v-if="!!message"
    size="middle"
    :message="message"
    :error="error"
  )
  form-layout(v-else)
    h3(slot="header") Задать вопрос по ПФ ДОД
    app-textarea(
      v-model="formData.question"
      slot="textarea"
      placeholder="Ваш вопрос"
      name="question"
      error-text="Обязательное поле"
      :rows="6"
      :v="$v.formData.question"
    )
    app-radio(
      v-model="radio"
      slot="radio"
      label="Получить ответ на почту"
      value="mail"
      id="mail"
      :modelValue="radio"
    )
    app-radio(
      v-model="radio"
      slot="radio"
      label="Получить ответ по телефону"
      value="phone"
      id="phone"
      :modelValue="radio"
    )
    app-input(
      v-model="formData.email"
      slot="input"
      v-if="radioState"
      key="email"
      name="email"
      placeholder="Ваша эл.почта"
      error-text="Укажите правильный адрес e-mail"
      :v="$v.formData.email"
    )
    app-input(
      v-model="formData.phone"
      slot="input"
      v-if="!radioState"
      key="email"
      name="phone"
      placeholder="Ваш телефон"
      error-text="Пожалуйста, введите корректный номер мобильного телефона."
      :mask="phoneMask"
      :v="$v.formData.phone"
    )
    ext-button(
      slot="button"
      :size="'normal'"
      @click="submitForm"
    ) Отправить
</template>

<script>
import FormLayout from './components/Layout.vue';
import ExtButton from '@/components/ext/Button.vue';
import Messages from '@/components/parts/messages';
import { Textarea as AppTextarea, Radio as AppRadio, Input as AppInput } from '@/components/form';

import { validationMixin } from 'vuelidate';
import { required, email, and } from 'vuelidate/lib/validators';

import { SUCCESS_DEFAULT_TEXT, ERROR_DEFAULT_TEXT } from './const.js';

export default {
  inject: ['$api'],

  components: {
    Messages,
    FormLayout,
    AppTextarea,
    AppRadio,
    AppInput,
    ExtButton,
  },

  props: {
    event: {
      type: Number,
      default: null,
    },

    profile: {
      type: Number,
      default: null,
    },
  },

  mixins: [validationMixin],

  validations() {
    const formData = {
      question: { required },
    };

    if (this.radioState) {
      formData.email = {
        required,
        email,
      };
    }

    if (!this.radioState) {
      formData.phone = {
        required,
        and: and(value => /^\+7\ \([1-9]\d\d\)\ \d\d\d\-\d\d\-\d\d$/.test(value)),
      };
    }

    return { formData };
  },

  data: () => ({
    message: '',
    error: false,
    formData: {},
    radio: 'mail',
  }),

  computed: {
    pageLink() {
      const { origin, pathname } = window.location;
      return `${origin}${pathname}`;
    },

    phoneMask: () => [
      '+',
      '7',
      ' ',
      '(',
      /[1-9]/,
      /\d/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
    ],

    radioState() {
      return this.radio === 'mail' ? true : false;
    },
  },

  mounted() {
    const { profile } = this.$store.state.user;
    if (profile) {
      this.formData = {
        email: profile.email,
        phone: profile.phone,
      };
    }
  },

  methods: {
    submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      const { question, email, phone } = this.formData;
      const { radioState, pageLink, event, profile } = this;

      const data = {
        question,
        url: pageLink,
      };

      if (email && radioState) data.email = email;
      if (phone && !radioState) data.phone = phone;
      if (event) data.from_event = event;
      if (profile) data.from_profile = profile;

      this.$api
        .post('pfdod/question/ask', { data })
        .then(res => {
          this.message = res.data.message ? res.data.message : SUCCESS_DEFAULT_TEXT;
        })
        .catch(err => {
          this.message = ERROR_DEFAULT_TEXT;
          this.error = true;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Modalform.vue?427f4c0c